import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../config";
import { LegacyJointProperty } from "../../../../api/src/types";
import { prepareHeaders } from "../utils";

interface BasePathParams {
  userId: string;
  docId: string;
}

// linter takes away this const

// eslint-disable-next-line
const legacyJointTagType = "legacy-joint" as const;

export const legacyJointApi = createApi({
  reducerPath: "legacyJointApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.api,
    prepareHeaders,
  }),
  tagTypes: [legacyJointTagType],
  endpoints: (builder) => ({
    getLegacyJoint: builder.query<
      LegacyJointProperty,
      BasePathParams & { id: string }
    >({
      query: ({ userId, docId, id }) => ({
        url: `users/${userId}/documents/${docId}/legacy-joint-properties/${id}`,
        method: "GET",
      }),

      providesTags: (_, __, query) => [
        { type: legacyJointTagType, id: query.id },
      ],
    }),
    getLegacyJointByUserId: builder.query<
      LegacyJointProperty[],
      BasePathParams
    >({
      query: ({ userId, docId }) => {
        return `users/${userId}/documents/${docId}/legacy-joint-properties`;
      },
      merge: (currentCache, newItems) => {
        const itemMap = new Map(currentCache.map((item) => [item.id, item]));
        newItems.forEach((item) => itemMap.set(item.id, item));
        return Array.from(itemMap.values());
      },

      providesTags: (result) => [
        ...(result?.map((legacyJoint) => ({
          type: legacyJointTagType,
          id: legacyJoint.id,
        })) ?? []),
        { type: legacyJointTagType, id: "LIST" },
      ],
    }),

    deleteLegacyJoint: builder.mutation<
      LegacyJointProperty,
      BasePathParams & { id: string }
    >({
      query: ({ userId, docId, id }) => ({
        url: `users/${userId}/documents/${docId}/legacy-joint-properties/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(
        { userId, docId, id },
        { dispatch, queryFulfilled },
      ) {
        await queryFulfilled;
        dispatch(
          legacyJointApi.util.updateQueryData(
            "getLegacyJointByUserId",
            { userId, docId },
            (draft: LegacyJointProperty[]) => {
              return draft.filter((item) => item.id !== id);
            },
          ),
        );
      },
    }),
  }),
});

export const {
  useGetLegacyJointQuery,
  useGetLegacyJointByUserIdQuery,
  useDeleteLegacyJointMutation,
} = legacyJointApi;
